export const ADD_SUCCESS = 'Новая скидка добавлена';
export const ADD_ERROR = 'Не удалось добавить скидку';
